import { render } from "./LocalSecurityAudits.vue?vue&type=template&id=61bb4862&scoped=true&ts=true"
import script from "./LocalSecurityAudits.vue?vue&type=script&lang=ts"
export * from "./LocalSecurityAudits.vue?vue&type=script&lang=ts"

import "./LocalSecurityAudits.vue?vue&type=style&index=0&id=61bb4862&scoped=true&lang=css"

import exportComponent from "/home/bwhite/Projects/bryanchriswhite-com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bb4862"]])

export default __exports__